<template>
  <empresa-container>
    <loading :active="isLoading" :can-cancel="false" :is-full-page="fullPage" :opacity="1"></loading>
    <div class="vld-parent">
      <standby-screen-component
        v-if="!this.$store.state.empresaVerificada"
      ></standby-screen-component>
      <div class="navbar-lower">
        <nav-bar
          :grupos="this.$store.state.grupos"
          style="z-index: 1002"
          :compartilhar="true"
        >
          <div class="nav-content nav-content-s" @click="Pesquisar()">
            <div class="nav-wrapper">
              <nav>
                <div class="nav-wrapper">
                  <form>
                    <div
                      class="input-field"
                      :style="
                        'background-color:white;border-style: solid;border-width: 1px;border-color: ' +
                        this.$store.state.empresa.cor_primaria +
                        ';color:' +
                        this.$store.state.empresa.cor_primaria
                      "
                    >
                      <input
                        id="search"
                        type="search"
                        required
                        placeholder="O que você procura?"
                      />
                      <label
                        class="label-icon"
                        for="search"
                        :style="
                          ' color:' + this.$store.state.empresa.cor_primaria
                        "
                      >

                        <i
                          :style="
                            'color:' + this.$store.state.empresa.cor_primaria
                          "
                          class="fas fa-search"
                        ></i>

                        <!--                        <i-->
                        <!--                        class="material-icons"-->
                        <!--                        :style="-->
                        <!--                            'color:' + this.$store.state.empresa.cor_primaria-->
                        <!--                          "-->
                        <!--                      >search</i-->
                        <!--                      >-->

                      </label
                      >
                      <i class="material-icons">close</i>
                    </div>
                  </form>
                </div>
              </nav>
            </div>
          </div>
        </nav-bar>
      </div>
      <div v-if="this.$store.state.empresaVerificada">
        <div
          :style="
            'background-color:' + this.$store.state.empresa.cor_cardapio_fundo
          "
        >
          <standby-screen-component></standby-screen-component>
          <informacoes-empresa></informacoes-empresa>
<!--          <div class="container">-->
<!--            <div class="" @click="Pesquisar()">-->
<!--              <div class="">-->
<!--                <nav>-->
<!--                  <div class="nav-wrapper">-->
<!--                    <form>-->
<!--                      <div class="input-field"-->
<!--                           :style="'background-color:white;border-style: solid;border-width: 1px;border-color: '+ this.$store.state.empresa.cor_primaria+';color:'+ this.$store.state.empresa.cor_primaria ">-->
<!--                        <input id="search" type="search" required placeholder="O que você procura?">-->
<!--                        <label class="label-icon" for="search" :style="'color:'+ this.$store.state.empresa.cor_primaria "><i-->
<!--                          class="material-icons"-->
<!--                          :style="'color:'+ this.$store.state.empresa.cor_primaria ">search</i></label>-->
<!--                        <i class="material-icons">close</i>-->
<!--                      </div>-->
<!--                    </form>-->
<!--                  </div>-->
<!--                </nav>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <br>
          <div class="container">
            <div class="page-section" v-if="$store.state.produtosPromocaoBool">
              <!-- <titulo-destacado
                :fundo="this.$store.state.grupoPromocional.cor_fundo_grupo"
                :titulo="this.$store.state.grupoPromocional.nome"
                :style="
                  'margin-bottom: 8px; color:' + this.$store.state.grupoPromocional.cor_fonte_grupo
                "
              ></titulo-destacado> -->
              <titulo-destacado class="lb-grupo " :titulo="titulodestaque"></titulo-destacado>
              <div class="row"> <!-- this.$store.state.produtosPromocao" -->
                <card
                  v-for="produto in orderedProd(this.$store.state.produtosPromocao, tipoOrdem)"
                  :produto="produto"
                  :em-promocao="true"
                  :key="'itempromocao-' + produto.id"
                ></card>
              </div>
            </div>

            <div class="page-section">
              <titulo-destacado
                :fundo="'white'"
                titulo="TODOS OS DEPARTAMENTOS"
                :style="
                  'border-style: solid;border-width: 1px;border-color: ' +
                  this.$store.state.empresa.cor_primaria +
                  ';color:' +
                  this.$store.state.empresa.cor_primaria
                "
              ></titulo-destacado>
              <div class="row" style="margin-bottom: 0px">
                <br />
                <destaques
                  v-for="grupo in this.$store.state.grupos"
                  :grupo="grupo"
                  :key="'grupo-' + grupo.grupo.id"
                ></destaques>
              </div>
            </div>
          </div>
          <meu-pedido-bloco-flutuante-component></meu-pedido-bloco-flutuante-component>
        </div>
      </div>
    </div>

    <!-- Modal Share -->
    <div id="modal1" class="modal">
      <div class="modal-content">
        <h4>Compartilhar</h4>
        <share-component></share-component>
      </div>
      <div class="modal-footer">
        <a class="modal-close waves-effect waves-green btn-flat">Voltar</a>
      </div>
    </div>
  </empresa-container>
</template>

<script>
import MeuPedidoBlocoFlutuanteComponent from "../components/MeuPedidoBlocoFlutuanteComponent";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TituloDestacado from "./template/TituloDestacado";
import NavBar from "./template/NavBar";
import Item from "../components/Item";
import InformacoesEmpresa from "../components/InformacoesEmpresa";
import MenuHorizontal from "./template/MenuHorizontal";
import Card from "../components/Card";
import Destaques from "../components/Destaques";
import EmpresaContainer from "../components/EmpresaContainer";
import ShareComponent from "../../app/components/ShareComponent.vue";
import StandbyScreenComponent from "../../app/components/StandbyScreenComponent.vue";
import SecureLS from "secure-ls";

export default {
  name: "HomeView",
  data() {
    return {
      empresa:this.$store.state.empresa,
      url:this.$store.state.url,
      gruposStore: this.$store.state.grupos,
      empresaExiste: false,
      isLoading: false,
      fullPage: true,
      dias: [],
      tipoOrdem: '',
      titulodestaque: this.$store.state.empresa.titulo_destaque
    };
  },
  updated() {
    document.getElementById("bodyMain").style =
      "background-color: " + this.$store.state.empresa.cor_secundaria;

    try {
      setTimeout(()=>{
        if (this.$route.query.produto) {
          this.$router.push('/' + this.$store.state.empresa_url + '/menu/pesquisar?produto=' + this.$route.query.produto);
        }
      },3000);
    } catch (exception) {
    }

  },
  mounted() {

    if (this.$route.query.produto) {
      this.isLoading = true;
    }

    $(document).ready(function () {
      $(".materialboxed").materialbox();
      $(".collapsible").collapsible();
      $(".scrollspy").scrollSpy();
      $(".tabs").tabs();
      $("ul.tabs").tabs();
      $(".modal").modal();
      $(".sidenav").sidenav();
      $(".dropdown-trigger").dropdown();

      $(".nav-content-s").hide();
    });

    this.titulodestaque = this.$store.state.empresa.titulo_destaque;

    if (this.empresa.ordem_lista_produtos == undefined)
    this.tipoOrdem = 'LIVRE'
    else {
      this.tipoOrdem = this.empresa.ordem_lista_produtos;
    }



  },
  components: {
    EmpresaContainer,
    Destaques,
    Card,
    MenuHorizontal,
    InformacoesEmpresa,
    Item,
    NavBar,
    TituloDestacado,
    MeuPedidoBlocoFlutuanteComponent,
    Loading,
    ShareComponent,
    StandbyScreenComponent
  },
  methods: {
    Pesquisar() {
      this.$router.push(
        "/" + this.$store.state.empresa_url + "/menu/pesquisar"
      );
    },
    detalhes(grupo) {
      var ls = new SecureLS();
      ls.set('grupo',grupo);
      this.$router.push('/' + this.$store.state.empresa_url + '/menu/grupo/'+grupo.grupo.nome + '/secao/' + 0 )
    },
    orderedProd: function (itens, ordem) {

      if (ordem == 'MAIOR PRECO')
        return _.orderBy(itens, ['valor_promocional'], ['desc']);

        if (ordem == 'MENOR PRECO')
        {
          return _.orderBy(itens, ['valor_promocional'], ['asc']);
        }

        if (ordem == 'ALFABETICA')
        return _.orderBy(itens, ['nome']);

        if (ordem  == 'LIVRE')
        return _.orderBy(itens, ['nome']);
    }
  },
};

$(window).scroll(function () {
  var scroll = $(window).scrollTop();
  if (scroll >= 100) {
    $(".nav-content-s").show();
  } else {
    $(".nav-content-s").hide();
  }
});
</script>

<style scoped>
.destaque{
  min-height: 80px;
  height: 80px;
  min-width: 80px;
  width: 80px;
  /*object-fit: scale-down;*/
  border-style:solid
}
div.scrollmenu {
  overflow: auto;
  white-space: nowrap;
}

div.scrollmenu a {
  display: inline-block;
  text-align: center;
  padding: 14px;
  text-decoration: none;
}

div.scrollmenu a:hover {
  background-color: #777;
}

@media only screen and (min-width: 601px) {
  nav,
  nav .nav-wrapper i,
  nav a.sidenav-trigger,
  nav a.sidenav-trigger i {
    height: 40px;
    line-height: 40px;
  }
}
@media only screen and (max-device-width: 768px) {
  /* Styles */
  .container {
    margin: 0 auto;
    max-width: 1280px;
    width: 97%;
  }
}

.fixed-action-btn {
  position: fixed;
  right: 23px;
  bottom: 60px;
  padding-top: 15px;
  margin-bottom: 0;
  z-index: 997;
}

.centered {
  position: fixed;
  top: 40%;
  left: 20%;
  transform: translate(-14%, -10%);
}
</style>



// WEBPACK FOOTER //
// src/app/views/HomeView.vue